import { Component, HostBinding, inject } from "@angular/core";
import { ConfigService } from "src/app/common/services/config.service";

@Component({
  selector: "app-footer",
  templateUrl: "./app.footer.component.html",
})
export class AppFooterComponent {
  private readonly configService = inject(ConfigService);

  readonly buildVersion = this.configService.buildVersion;

  protected readonly Number = Number;

  @HostBinding("class")
  environment = this.configService.environment;
}
